import React from "react";
import { Route, RouteComponentProps, withRouter } from "react-router-dom";
import { fomatParentPath } from "../../utils";
import { MobNoPermission } from "../../lib";

function MSpaceNoPermission(props: RouteComponentProps) {
  let parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`_81b5pv`} exact path={`${parentPath}/mobile/uk/space/noPermission`}>
      <MobNoPermission weId={`_dxquyh`}/>
    </Route>
  )
}

export default withRouter(MSpaceNoPermission);